import Link from 'next/link';
import { useRouter } from 'next/router';
import { memo } from 'react';
import Categories from '../Categories';
import Img from '../../common/Img';
import dayjs from 'dayjs';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import styles from '../../../../styles/components/section/stories/post/Main.module.scss';

const Main = memo(({ story }) => {
    const router = useRouter();
    const onClickBack = () => {
        router.back();
    };
    let postCategory = story.fields.category;

    return (
        <div className={styles.main}>
            <Categories spNone={false} postCategory={postCategory} />
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <div className={styles.head}>
                        <Link href={story.fields.slug}>
                            <a className={styles.headCategory}>
                                {story.fields.category}
                            </a>
                        </Link>
                        <span className={styles.headDate}>
                            {dayjs(story.fields.publishedAt).format(
                                'YYYY-MM-DD'
                            )}
                        </span>
                        <h2 className={styles.headTitle}>
                            {story.fields.title}
                        </h2>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.bodyThumb}>
                            {story.fields.image ? (
                                <Img
                                    src={
                                        `https:` +
                                        story.fields.image.fields.file.url +
                                        `?fm=webp&q=50`
                                    }
                                    loading="eager"
                                    alt={story.fields.alt}
                                />
                            ) : (
                                <Img
                                    src="/image/stories/post/preset.jpg"
                                    loading="eager"
                                    alt={story.fields.alt}
                                />
                            )}
                        </div>
                        <div className={styles.bodyArticle}>
                            {documentToReactComponents(story.fields.body, {
                                renderText: text => {
                                    return text.split('\n').reduce((children, textSegment, index) => {
                                        return [...children, index > 0 && <br key={index} />, textSegment];
                                    }, []);
                                },
                                renderNode: {
                                    // eslint-disable-next-line react/display-name
                                    [BLOCKS.EMBEDDED_ASSET]: (node) => (
                                        <Img
                                            src={
                                                'https:' +
                                                node.data.target.fields.file.url
                                            }
                                            alt="story.fields.alt"
                                        />
                                    ),
                                },
                            })}
                        </div>
                    </div>
                    <div className={styles.back}>
                        <button
                            className={`${styles.backLink} js-hover js-hover__btn__key`}
                            onClick={() => onClickBack()}
                        >
                            <span
                                className={`${styles.backText} js-hover__btn-text`}
                            >
                                BACK
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
});

Main.displayName = 'Main';

export default Main;
